import { TASK_TEXTS } from '@till-erp/collab/values';
import type { TaskItem } from './api.ts';

/** Freie Aufgabe (Story 23.1): ohne Datensatz. */
export function isFree(task: Pick<TaskItem, 'entityType' | 'entityId'>): boolean {
  return task.entityType === null || task.entityId === null;
}

/**
 * Datensatz-Teil einer Aufgabe: „Auftrag 4711 Muster GmbH“ oder bei freien Aufgaben „Freie Aufgabe“ – gleich in der
 * Aufgabenzeile und auf der Board-Karte (Story 23.2). Gesperrt (Story 23.17, Rolle Mitarbeiter) liefert der Server statt
 * des Namens nur die Nummer: „Auftrag 202724536“; angezeigt mit Schloss über `LockedRecord`.
 */
export function recordLabel(task: Pick<TaskItem, 'entityType' | 'entityId' | 'entityLabel' | 'entityName'>): string {
  return isFree(task) ? TASK_TEXTS.freeTask : `${task.entityLabel ?? ''} ${task.entityName ?? ''}`.trim();
}

/** Bezug gesperrt (Story 23.17): nur Art und Nummer, kein Link zum Datensatz. */
export function isLockedRecord(task: Pick<TaskItem, 'entityType' | 'entityId' | 'entityLocked'>): boolean {
  return !isFree(task) && task.entityLocked;
}
